module.exports = __webpack_public_path__ + "img/HQ-DNC-V1.4c39f1aa.jpg";